<template class="page-content">
  <ModalLayout :ref="modalRef"
    modal-id="unauthorizedModal"
    :loading="false"
    modal-style="background-color: #000"
    @close="modalClosed()">
    <template #modal-header>
      <h5>Unauthorized</h5>
    </template>
    <template #modal-body>
      You are not authorized to view this content.

      <hr>
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="modalClosed">Close</button>
    </template>
  </ModalLayout>
</template>

<script>
import ModalLayout from "@/src/components/shared/ModalLayout.vue";

export default {
  components: {
    ModalLayout
  },
  props: {
    modalRef: { type: String, required: true },
  },
   data() {
    return {
      modalRef: 'unauthorizedModal'
    }
  },
  methods: {
    modalClosed() {
      this.$emit('close');
    },
  },
};
</script>